const BaseError = require('make-error').BaseError;

class PageSizeError extends BaseError {
    constructor(maxPageSize = 1000, errorMessage='Page size must be a number between 1 and ') {
        super(errorMessage + maxPageSize);
        this._isUserError = true;
    }
}

module.exports = PageSizeError;
